export const TIMER = [
  {
    value: 1,
    label: 'minutos',
  },
  {
    value: 2,
    label: 'horas',
  },
  {
    value: 3,
    label: 'dias',
  },
];

export const STATUS_CANCELLED = 200;

export function parseStatus(status) {
  switch (status) {
    case 20:
    case 27:
      return {
        id: status,
        label: 'Novo pedido',
        bgColor: '#e29a09',
        color: '#fff',
      };
    case 30:
      return {
        id: status,
        label: 'Confirmado',
        bgColor: '#4fa444',
        color: '#fff',
      };
    case 50:
      return {
        id: status,
        label: 'Em produção',
        bgColor: '#4a90e2',
        color: '#fff',
      };
    case 60:
      return {
        id: status,
        label: 'Pronto para retirar',
        bgColor: '#4fa444',
        color: '#fff',
      };
    case 70:
      return {
        id: status,
        label: 'Em Entrega',
        bgColor: '#3d3d3d',
        color: '#fff',
      };
    case 80:
      return {
        id: status,
        label: 'Entregue',
        bgColor: '#fff',
        borderColor: '#979797',
        color: '#333',
      };
    case STATUS_CANCELLED:
      return {
        id: status,
        label: 'Cancelado',
        bgColor: '#9e2832',
        color: '#fff',
      };
    default:
      return {
        id: status,
        label: 'Status não identificado',
        bgColor: '#CCC',
        color: '#fff',
      };
  }
}

export const STATUS = [
  {
    id: 0,
    label: 'Todos os pedidos',
    value: 0,
    color: '#333',
    bgColor: '#fff',
    borderColor: '#ccc',
  },
  {
    id: 20,
    label: 'Novo pedido',
    value: 20,
    bgColor: '#e29a09',
    color: '#fff',
  },
  {
    id: 30,
    label: 'Confirmado',
    value: 30,
    bgColor: '#4fa444',
    color: '#fff',
  },
  {
    id: 50,
    label: 'Em produção',
    value: 50,
    bgColor: '#4a90e2',
    color: '#fff',
  },
  {
    id: 60,
    label: 'Pronto para retirar',
    value: 60,
    bgColor: '#4fa444',
    color: '#fff',
  },
  {
    id: 70,
    label: 'Em Entrega',
    value: 70,
    bgColor: '#3d3d3d',
    color: '#fff',
  },
  {
    id: 80,
    label: 'Entregue',
    value: 80,
    bgColor: '#fff',
    borderColor: '#979797',
    color: '#333',
  },
  {
    id: 200,
    label: 'Cancelado',
    value: 200,
    bgColor: '#9e2832',
    color: '#fff',
  },
];

export const ORDER_SERVICES = {
  TAKEAWAY: 1,
  DELIVERY: 2,
  DINEIN: 10,
};

export const PAYMENTS = [
  {
    id: 1,
    label: 'Pago',
    color: '#4fa444',
  },
  {
    id: 0,
    label: 'Não pago',
    color: '#d23f31',
  },
];

export const PAYMENT_METHODS = [
  {
    id: 2,
    label: 'Débito',
    color: '',
  },
  {
    id: 3,
    label: 'Dinheiro',
    color: '',
  },
  {
    id: 4,
    label: 'Vale Refeição',
    color: '',
  },
];

export const ORDER_TYPE = [
  {
    id: 1,
    label: 'Cliente retira no balcão embalado para viagem.',
    name: 'TAKE_AWAY',
    labelName: 'RETIRADA NO BALCÃO',
    display: {
      first: 'Para viagem',
      last: '',
    },
  },
  {
    id: 2,
    label: 'Entrega para delivery',
    name: 'DELIVERY',
    labelName: 'DELIVERY',
    display: {
      first: 'Delivery',
      last: '',
    },
  },
  {
    id: 3,
    label: 'Entrega na mesa',
    name: 'SHORT_DELIVERY',
    labelName: 'SERVIR NA MESA',
    display: {
      first: 'Loja',
      last: 'Mesa',
    },
  },
  {
    id: 4,
    label: 'Voucher',
    name: 'VOUCHER',
    labelName: 'VOUCHER',
    display: {
      first: 'Voucher',
      last: '',
    },
  },
  {
    id: 6,
    label: 'Pedido na comanda',
    name: 'IN_STORE',
    labelName: 'NA COMANDA',
    display: {
      first: 'Comanda',
      last: '',
    },
  },
  {
    id: 10,
    label: 'Cliente retira no balcão para consumir em loja.',
    name: 'DINEIN',
    labelName: 'DINEIN',
    display: {
      first: 'Dine In',
      last: '',
    },
  },
];

export const ID_ORDER_TYPE = {
  retiradaBalcao: 1,
  voucher: 4,
  pedidoNaComanda: 6,
};

export const ORDER_SELECT_TYPE = [
  {
    id: 0,
    label: 'Todos os Tipos',
    value: 0,
  },
  {
    id: 1,
    label: 'Retirada no Balcão',
    name: 'TAKE_AWAY',
    value: 1,
  },
  {
    id: 2,
    label: 'Entrega para delivery',
    name: 'DELIVERY',
    value: 2,
  },
  {
    id: 3,
    label: 'Entrega na mesa',
    name: 'SHORT_DELIVERY',
    value: 3,
  },
  {
    id: 4,
    label: 'Pedido na comanda',
    name: 'IN_STORE',
    value: 4,
  },
];

export const HOURS = [
  {
    id: 1,
    label: 'Últimas 24 horas',
    value: 24,
  },
  {
    id: 2,
    label: 'Últimas 48 horas',
    value: 48,
  },
  {
    id: 3,
    label: 'Últimas 72 horas',
    value: 72,
  },
  {
    id: 4,
    label: 'Últimas 96 horas',
    value: 96,
  },
];

export const REASONS = [
  {
    id: 1,
    label: 'Problemas de conexão com o estabelecimento.',
  },
  {
    id: 2,
    label: 'O estabelecimento não possui o item solicitado.',
  },
  {
    id: 3,
    label: 'Contratempo com entregadores.',
  },
  {
    id: 4,
    label: 'Cliente solicitou o cancelamento na entrega.',
  },
];

export const PAYMENT_MONEY = 3;
export const PAYMENT_DEBIT = 2;
export const PAYMENT_TICKET = 4;
export const STATUS_NOT_PAID = 0;

export const STATUS_DELIVERED = 80;
export const STATUS_TAKE = 60;
export const STATUS_IN_DELIVERY = 70;

export const TAKE_AWAY = 1;
export const DELIVERY = 2;
export const SHORT_DELIVERY = 3;
export const VOUCHER = 4;
export const IN_STORE = 6;



// WEBPACK FOOTER //
// ./src/helpers/constants.js